import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { TotadminPermission } from 'data/__generated__';
import { useHasPermission } from 'hooks/useHasPermission';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { UserList } from './components';
import { Link } from 'react-router-dom';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

export const Users = () => {
    const canManagePermissions = useHasPermission(TotadminPermission.PermissionsManage);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.users} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to="/user/create-toteam">
                        <TotemPrimaryButton
                            disabled={!canManagePermissions}
                            requiredPermissions={[TotadminPermission.PermissionsManage]}
                        >
                            Ajouter un utilisateur
                        </TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <UserList />
            </Content>
        </Container>
    );
};

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
`;
